import { createGtm } from '@gtm-support/vue-gtm'
import type { App } from 'vue'
import type { Router } from 'vue-router'

const GTM_ID_PATTERN = /^GTM-[A-Z0-9]+$/

let context: { app: App; router: Router } | null = null
let installedId: string | null = null

export function setGtmContext(app: App, router: Router): void {
    context = { app, router }
}

export function installGtm(id: string | null | undefined): void {
    if (!id || !GTM_ID_PATTERN.test(id) || installedId || !context) {
        return
    }
    installedId = id

    const dataLayer = (window.dataLayer = window.dataLayer || [])
    window.gtag =
        window.gtag ||
        function (...args: unknown[]) {
            dataLayer.push(args)
        }

    context.app.use(
        createGtm({
            id,
            enabled: true,
            loadScript: true,
            defer: true,
            vueRouter: context.router,
        })
    )
}
